import React, { useState } from "react";
import DialogWrapper from "../../custom-ui/dialog/Dialog";

export default function CommunityConfirmDialog({
  title,
  message,
  confirmLabel = "Delete",
  cancelLabel = "Cancel",
  onClose,
  onConfirm,
}: {
  title: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
  onClose: () => void;
  onConfirm: () => void | Promise<void>;
}) {
  const [isLoading, setIsLoading] = useState(false);

  const handleConfirm = async () => {
    setIsLoading(true);
    try {
      await onConfirm();
      onClose();
    } catch {
      // Keep dialog open; caller should show toast on failure.
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <DialogWrapper
      title={title}
      size="max-w-md"
      onClose={onClose}
      displayCloseIcon
    >
      <div>
        <p className="text-sm text-[#4B5563] leading-relaxed">{message}</p>
        <div className="flex justify-end gap-3 pt-6">
          <button
            type="button"
            onClick={onClose}
            disabled={isLoading}
            className="px-4 py-2 text-sm font-medium text-[#15415E] border border-gray-200 rounded-lg hover:bg-gray-50 disabled:opacity-50"
          >
            {cancelLabel}
          </button>
          <button
            type="button"
            onClick={handleConfirm}
            disabled={isLoading}
            className="px-4 py-2 text-sm font-semibold text-white bg-red-600 rounded-lg hover:bg-red-700 disabled:opacity-50"
          >
            {isLoading ? "Deleting…" : confirmLabel}
          </button>
        </div>
      </div>
    </DialogWrapper>
  );
}
